<template>
  <div id="app">
    <router-view />
    <GlobalToast />
  </div>
</template>

<script>
import GlobalToast from "@/components/GlobalToast.vue";

export default {
  name: "App",
  components: {
    GlobalToast
  },
  async mounted() {
    try {
      await this.$store.dispatch("actionSetUserInfo");
    } catch (error) {
      // Ignore here. Pages that need auth will handle their own redirect logic.
    }
  }
};
</script>

<style>
:root {
  --font-ui: "Lato", "Noto Sans TC", sans-serif;
}

html,
body,
#app {
  height: 100%;
  margin: 0;
}

html {
  font-size: 17px;
}

body {
  background: #0b1a23;
  font-size: 1rem;
  line-height: 1.5;
  color: #1f2a33;
  font-family: var(--font-ui);
}

button,
input,
select,
textarea {
  font: inherit;
  font-family: var(--font-ui);
}
</style>
